import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import styled, { css } from 'styled-components';
export function PopupButton({ asLink = false, active = false, children, prependComponent, appendComponent, ...props }) {
    const tag = asLink ? 'a' : 'button';
    return (_jsxs(PopupButtonRoot, { as: tag, "$active": active, ...props, children: [prependComponent, _jsx(PopupButtonLabel, { children: children }), appendComponent] }));
}
const PopupButtonLabel = styled.div `
    font-size: 1rem;
    letter-spacing: -0.04em;
    min-width: 0%;
    white-space: nowrap;
    text-overflow: ellipsis;
    overflow: hidden;
    flex: 1;
    font-weight: 500;
`;
const PopupButtonRoot = styled.div `
    border: 0;
    color: #ffffff;
    align-items: center;
    display: flex;
    font-size: 1rem;
    gap: 0.75rem;
    height: 3.75rem;
    padding: 0.75rem 1rem;
    background: rgba(53, 54, 49, 0.55);
    border-radius: 0.875rem;
    box-sizing: border-box;
    min-height: 3.75rem;
    width: 100%;
    text-align: left;
    transition: 200ms background-color;
    cursor: pointer;

    a& {
        text-decoration: none;
    }

    button& {
        appearance: none;
    }

    &:hover {
        background: rgba(53, 54, 49, 0.65);
        transition-duration: 50ms;
    }

    &:active {
        transform: translateY(0.0625rem);
    }

    ${({ $active = false }) => $active &&
    css `
            &,
            &:hover {
                background: rgba(53, 54, 49, 0.85);
            }
        `}
`;
